module.exports = __webpack_public_path__ + "img/cod-on-pinto-beans.93f0b9a6.jpg";